/**

	this file contains compatibily functions that are used to enable old functions that were used in the cfnGridOld

**/

var rowClasses = {
  ELEMENT_INVALID_AND_ACTIVE: function(ob) {
    if (ob) {
      return (
        (ob.invalid ? 'elementInvalid' : '') +
        ' ' +
        (!ob.active ? 'elementInactive' : '')
      );
    } else return '';
  },
  ELEMENT_INVALID: function(ob) {
    if (ob) return ob.invalid ? 'elementInvalid' : '';
    else return '';
  },
  ELEMENT_INACTIVE: function(ob) {
    if (ob) return !ob.active ? 'elementInactive' : '';
    else return '';
  },
  ELEMENT_NOINACTIVE: function(ob) {
    return '';
  },
  GEOMETRY_STATE: function(ob) {
    if (ob && ob.state)
      return ob.state.indexOf('G') == -1 ? 'elementInactive' : '';
    else if (ob && ob.status)
      return ob.status.indexOf('G') == -1 ? 'elementInactive' : '';
    else return '';
  },
  MAINCOMPANYROW: function(ob) {
    if (ob) return ob.isCompany ? 'mainCompanyRow' : '';
    else return '';
  }
}; // special row class definitions

var cfnGridCompatibility = {
  addControllerFunctions: function(ctrl, $scope, $element, $filter, $log) {
    /*
     deprecated
     returns the row in a format of the old grid
     */
    ctrl.getSelectedRow = function() {
      return ctrl.getSelectedRows()[0];
    };
    /*
     deprecated
     returns the rows in a format compatible to the old grid format
     */
    ctrl.getSelectedRows = function() {
      var result = [];
      $.each($scope.selected, function(k, v) {
        var rowindex = k;
        var rowData = v;
        result.push({ index: rowindex, data: rowData });
      });
      return result;
    };
  },
  convertRowClasses: function(v, rClasses) {
    switch (v) {
      case 'ELEMENT_INVALID_AND_ACTIVE':
        rClasses['elementInvalid'] = 'item.invalid';
        rClasses['elementInactive'] = '!item.active';
        break;

      case 'ELEMENT_INVALID':
        rClasses['elementInvalid'] = 'item.invalid';
        break;

      case 'ELEMENT_INACTIVE':
        rClasses['elementInactive'] = '!item.active';
        break;

      case 'ELEMENT_NOINACTIVE':
        rClasses['elementInactive'] = 'false';
        break;

      case 'GEOMETRY_STATE':
        rClasses['elementInactive'] =
          'item.state.indexOf("G")==-1||item.status.indexOf("G")==-1';
        break;

      case 'MAINCOMPANYROW':
        rClasses['mainCompanyRow'] = 'item.isCompany';
        break;

      case 'ELEMENT_PROCESSED':
        rClasses['elementprocessed'] = 'item.isProcessed';
    }
  }
};

global.cfnGridCompatibility = cfnGridCompatibility;
